import { useCallback } from "react"
import { toaster } from "../components/UI/toaster"

const useCustomToast = () => {
  const showToast = useCallback(
    (title: string, description: string, type: "success" | "error") => {
      toaster.create({
        title,
        description,
        type,
        closable: true,
        duration: 5000,
      })
    },
    [toaster],
  )

  return showToast
}

export default useCustomToast
